import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  createReportResolution,
  CreateReportResolutionPayload,
} from '@/services/create-report-resolution'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export const useCreateReportResolution = (
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  reportId: string,
) => {
  const mutation = useMutation({
    mutationFn: (payload: CreateReportResolutionPayload) =>
      createReportResolution(
        treatment,
        culture,
        diagnosisId,
        reportId,
        payload,
      ),
    onError: (error: Error) => {
      toast.error(
        `Ocorreu um erro ao enviar sua solicitação. Tente novamente. [${error?.message}]`,
      )
    },
  })

  return mutation
}
